import { saveCartReducer } from './manage-carts-reducer';
import { activeCartReducer } from '../reducer/active-cart.reducer';
import { createCartReducer } from '../reducer/create-cart.reducer';
import { InjectionToken } from '@angular/core';
import { ActionReducerMap, MetaReducer } from '@ngrx/store';
import { StateWithSavedCarts } from '../state/cart-details.state';
import { sharedManageCartsReducer } from './shared-manage-cart.reducer';


export const reducerToken: InjectionToken<ActionReducerMap<StateWithSavedCarts>> =
  new InjectionToken<ActionReducerMap<StateWithSavedCarts>>('SavedCartReducers');

export const customMetaReducers: MetaReducer<StateWithSavedCarts>[] = [];

export const combinedCartReducer: ActionReducerMap<StateWithSavedCarts> = {
  activeCart: activeCartReducer,
  createCart: createCartReducer,
  savedCart: saveCartReducer,
  sharedCartData: sharedManageCartsReducer,
};